import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";
import PulseLoader from "react-spinners/PulseLoader";
import { Image, Anchor } from "hesus-ui-kit";
import { getDateFormat } from "@utils/datePickerUtils";
import DocumentPreview from "../../../../Document/DocumentPreview/DocumentPreview";
import editIcon from "@icons/ic-edit-blue.svg";
import planIcon from "@icons/ic-dispute-plan-order.svg";
import dotIcon from "@icons/ic-dot-navy-blue.svg";

import {
  GridRow,
  GridSubLabel,
  GridSubItem,
  DocumentRow,
  DocumentName,
} from "../../DisputeList.styled";
import "../../DisputeList.scss";
import { disputeTypeText } from "@utils/constants";

const ListingData = (props) => {
  const { t, page, isLoading, disputeData, onDisputeEdit } = props;
  const [selectedDocument, setSelectedDocument] = useState(null);

  const openPreview = (document) => setSelectedDocument(document);
  const closePreview = () => setSelectedDocument(null);

  return (
    <>
      {isLoading && (
        <div className="suggestions-list-loading">
          <PulseLoader color="#1bace4" size={15} />
        </div>
      )}
      {!isLoading && disputeData?.length === 0 && (
        <GridRow>
          <GridSubLabel textAlign="center">{t("NO_DATA")}</GridSubLabel>
        </GridRow>
      )}
      {!isLoading &&
        disputeData?.length > 0 &&
        disputeData.map((dispute, disputeIndex) => {
          return (
            <GridRow
              key={`dispute-list-${dispute.id}${disputeIndex}`}
              column={
                page === "main"
                  ? "10% 10% 10% 15% 10% 24% 8% 13%"
                  : "10% 10% 17% 12% 28% 10% 13%"
              }
              marginBottom="0px"
              gap="1px;"
              borderLeft="2px solid #767676"
              borderBottom="2px solid #767676"
              borderRight="2px solid #767676"
            >
              <GridSubItem
                color="#0A4986"
                fontStyle="normal"
                padding="5px"
                fontWeight="400"
                textAlign="center"
                vertical-align="middle"
                borderRight="2px solid rgb(118, 118, 118)"
              >
                {getDateFormat(dispute?.date, "YYYY-MM-DD")}
              </GridSubItem>
              {page === "main" && (
                <GridSubItem
                  color="#0a4986"
                  fontStyle="normal"
                  padding="5px"
                  fontWeight="700"
                  textAlign="left"
                  vertical-align="middle"
                  borderRight="2px solid rgb(118, 118, 118)"
                >
                  <Anchor
                    className="dispute-list__link"
                    url={`/site/view/${dispute?.site?.id}/general-info`}
                    target="_blank"
                  >
                    {` #${dispute?.site?.id}`} {` - ${dispute?.site?.name}`}
                  </Anchor>
                </GridSubItem>
              )}
              <GridSubItem
                color="#474747"
                fontStyle="normal"
                padding="5px"
                fontWeight="400"
                textAlign="center"
                vertical-align="middle"
                borderRight="2px solid rgb(118, 118, 118)"
              >
                {t(disputeTypeText[dispute.type])}
              </GridSubItem>
              <GridSubItem
                color="#0a4986"
                fontStyle="normal"
                padding="5px"
                fontWeight="700"
                textAlign="left"
                vertical-align="middle"
                borderRight="2px solid rgb(118, 118, 118)"
              >
                {dispute.type === 4 && t("DISPUTE_RESPONSIBILITY_HESUS")}
                {dispute.type !== 4 && dispute.responsible.name}
              </GridSubItem>
              <GridSubItem
                color="#474747"
                fontStyle="normal"
                padding="5px"
                fontWeight="400"
                textAlign="left"
                vertical-align="middle"
                borderRight="2px solid rgb(118, 118, 118)"
              >
                {dispute.fees ? dispute.fees : " - "}
              </GridSubItem>
              <GridSubItem
                color="#474747"
                fontStyle="normal"
                padding="5px"
                fontWeight="400"
                textAlign="left"
                vertical-align="middle"
                borderRight="2px solid rgb(118, 118, 118)"
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: dispute.details,
                  }}
                ></div>
                {dispute?.documents?.length !== "" &&
                  dispute?.documents?.map((document, documentIndex) => {
                    return (
                      <DocumentRow
                        key={`dispute-list-document-${dispute.id}${document.id}${documentIndex}`}
                      >
                        <GridRow gap="0rem" column="1fr auto">
                          <DocumentName
                            onClick={() => openPreview(document)}
                            className="dispute-list__document-link"
                          >
                            <Image
                              className="deleteImage"
                              src={dotIcon}
                              alt="delete"
                              styles={{ marginRight: "6px" }}
                            />
                            {document?.fileName}
                          </DocumentName>
                        </GridRow>
                      </DocumentRow>
                    );
                  })}
              </GridSubItem>
              <GridSubItem
                color="#474747"
                fontStyle="normal"
                padding="5px"
                fontWeight="400"
                textAlign="center"
                vertical-align="middle"
                borderRight="2px solid rgb(118, 118, 118)"
              >
                {dispute.createdBy?.firstname +
                  " " +
                  dispute.createdBy?.lastname}
              </GridSubItem>
              <GridSubItem
                color="#474747"
                fontStyle="normal"
                padding="5px"
                fontWeight="400"
                textAlign="center"
                vertical-align="middle"
              >
                <Image
                  src={editIcon}
                  className="dispute-list__action-icon"
                  onClick={() =>
                    onDisputeEdit(
                      dispute?.id,
                      dispute?.suppliersPlanningLine?.id,
                      dispute?.site?.id
                    )
                  }
                  alt={t("DISPUTE_ACTION_TOOLTIP_EDIT")}
                  title={t("DISPUTE_ACTION_TOOLTIP_EDIT")}
                />
                {dispute?.suppliersPlanningLine?.clientOrderServiceId && (
                  <Image
                    src={planIcon}
                    className="dispute-list__action-icon-margin"
                    onClick={() =>
                      window.open(
                        `/planning/${dispute?.suppliersPlanningLine?.clientOrderServiceId}/suppliers`,
                        "_blank"
                      )
                    }
                    alt={t("DISPUTE_ACTION_TOOLTIP_PLANNING_LINE")}
                    title={t("DISPUTE_ACTION_TOOLTIP_PLANNING_LINE")}
                  />
                )}
              </GridSubItem>
            </GridRow>
          );
        })}
      {selectedDocument && (
        <DocumentPreview document={selectedDocument} onClose={closePreview} />
      )}
    </>
  );
};

ListingData.propTypes = {
  t: PropTypes.func.isRequired,
  page: PropTypes.string,
};

ListingData.defaultProps = {
  page: "main",
};

export default withTranslation()(ListingData);
